"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillingService = void 0;
class BillingService {
    constructor($http) {
        this.$http = $http;
    }
    static factory($http) {
        return new BillingService($http);
    }
    getAgentBillingStatus(agentId) {
        return this.$http.get('/v1/agents/billing/' + agentId + '/status').then((resp) => resp.data);
    }
    getAgentBillingConfig(agentId) {
        return new Promise((resolve, reject) => {
            this.$http.get('/v1/billing/configs/' + agentId, {
                transformResponse: [function (data) { return data; }] // Prevent automatic JSON parsing
            }).then(resp => {
                // Try to parse as JSON
                var parsedData;
                try {
                    parsedData = JSON.parse(resp.data);
                    resolve(parsedData);
                }
                catch (e) {
                    // If not JSON, treat as error message
                    reject(new Error('Invalid JSON response'));
                }
            }).catch((resp) => reject(resp));
        });
    }
}
exports.BillingService = BillingService;
angular.module('callX').service('BillingService', ['$http', BillingService.factory]);
